import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider, useApp } from './contexts/AppContext';
import Layout from './components/Layout';
import ErrorBoundary from './components/ErrorBoundary';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import LeaveRequest from './components/LeaveRequest';
import LeaveOverview from './components/LeaveOverview';
import OvertimeTracker from './components/OvertimeTracker';
import Calendar from './components/Calendar';
import AdminPanel from './components/AdminPanel';
import OutlookSyncPage from './pages/OutlookSyncPage';
import MedewerkerVerlof from './components/MedewerkerVerlof';
import Ziekmelding from './components/Ziekmelding';
import FlexDashboard from './components/FlexDashboard';
import FlexWeekplanner from './components/FlexWeekplanner';
import UserGuide from './components/UserGuide';
import Indienen from './components/Indienen';

function ProtectedApp() {
  const { currentUser, isAdmin, isManager, isFlexkracht, canManage, loading } = useApp();

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', flexDirection: 'column', color: '#605e5c' }}>
        <div style={{ width: 40, height: 40, border: '4px solid #f3f3f3', borderTop: '4px solid #E86E1C', borderRadius: '50%', animation: 'spin 1s linear infinite', marginBottom: 16 }} />
        <p>Gegevens laden...</p>
      </div>
    );
  }

  if (!currentUser) return <Login />;

  return (
    <Layout>
      <ErrorBoundary>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        {/* Gecombineerde indienen pagina (verlof/ziek/overuren) */}
        {!isFlexkracht && <Route path="/indienen" element={<Indienen />} />}
        {/* Directe routes (ook gebruikt door Indienen component) */}
        {!isFlexkracht && <Route path="/verlof-aanvragen" element={<LeaveRequest />} />}
        {!isFlexkracht && <Route path="/ziekmelding" element={<Ziekmelding />} />}
        {!isFlexkracht && <Route path="/overuren" element={<OvertimeTracker />} />}
        {!isFlexkracht && <Route path="/verlof-overzicht" element={<LeaveOverview />} />}
        <Route path="/kalender" element={<Calendar />} />
        {/* Flex: voor flexkracht profiel, medewerker met flex profiel, manager, admin */}
        {(isFlexkracht || canManage || currentUser?.HeeftFlexProfiel) && <Route path="/flex" element={<FlexDashboard />} />}
        {/* Flex weekplanner: medewerkers met flex/ADV uren + managers + admin */}
        {(!isFlexkracht && ((currentUser?.WeekFlexUren || 0) > 0 || canManage)) && <Route path="/flex-planner" element={<FlexWeekplanner />} />}
        {canManage && <Route path="/verlof-medewerkers" element={<MedewerkerVerlof />} />}
        {(isAdmin || isManager) && <Route path="/admin" element={<AdminPanel />} />}
        {isAdmin && <Route path="/outlook-sync" element={<OutlookSyncPage />} />}
        <Route path="/handleiding" element={<UserGuide />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </ErrorBoundary>
    </Layout>
  );
}

function App() {
  return (
    <AppProvider>
      <ProtectedApp />
    </AppProvider>
  );
}

export default App;
